import { useContext } from 'react';

import { FilterSettingsContext } from './filterSettingsStoreProvider';

const useFilterSettingsStore = () => {
  const context = useContext(FilterSettingsContext);
  if (context === undefined) {
    throw new Error('useFilterSettingsStore must be used within a FilterSettingsProvider');
  }
  return context;
};

export { useFilterSettingsStore };
